import React from 'react'
import './about.css'
import img_about from '../../Assets/about.jpg'
import img_about1 from '../../Assets/about1.jpg'


const About = () => {
  return (
    <section id="about" className="section about">
      <div className="about__content container flex grid">
        <article className="about__text">
          <span>Dream Vacation Destination</span>
          <h1>Plan the Trip of a Lifetime with Ease</h1>
          <p>Whether you're looking for a romantic getaway, a family-friendly adventure, or a solo journey to explore Bandung, Go2Bandoeng agency can provide you with a custom-tailored itinerary that exceeds your expectations.</p>
          <br />
          <button className="about__btn">More Info</button>
        </article>

        <article className="about__img__content flex grid">
            <img src={img_about1}  className="about__img1" alt='about__img1'/>
            <img src={img_about}  className="about__img" alt='about__img'/>
        </article>
      </div>
    </section>
  )
}

export default About